// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
// material
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Page from '../../components/Page';
import { Formik } from 'formik';
import { TimePicker, LocalizationProvider } from '@mui/lab';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import styled from '@emotion/styled';
import * as Yup from 'yup';
import { useAppSelector } from '../../store/hooks';
import { useFindParkingSpaceLocationByIdMutation } from '../../store/api/parkingsApi';
import Loading from '../../components/Loading';
import LocationSearchInput from '../../sections/@dashboard/parkingspaces/PlaceLocationAutoComplete';
import { useGetEnumDataMutation } from '../../store/api/enumApi';
import { getSpecificEnumData, setEnumData } from '../../store/state/enumSlice';
import { useGetParkingTypeDataMutation } from '../../store/api/parkingTypeApi';
import { useDispatch } from 'react-redux';

const Input = styled('input')({
  display: 'none',
});

const ParkingSchema = Yup.object().shape({
  capacity: Yup.number().required('Capacity is required').min(10, 'Capacity must be at least 10'),
  closeAt: Yup.string().required('closing time is required'),
  description: Yup.string().required('Description is required'),
  name: Yup.string().required('Name is required'),
  serviceProviderId: Yup.string(),
  openAt: Yup.string().required('opening time is required'),
  phoneNumber: Yup.string().required('Phone number is required'),
  hourlyLimit: Yup.number().required('Hourly limit is required').min(0).max(24),
  hourlyRate: Yup.number().required('Hourly rate is required').min(0).max(999),
  dailyLimit: Yup.number().required('Daily limit is required').min(0).max(24),
  dailyRate: Yup.number().required('Daily rate is required').min(0).max(999),
  tierType: Yup.string().required('Tier Type is required'),
  commission: Yup.string().required('Commission is required'),
  termAndCondition: Yup.boolean().required('Terms and condition is required'),
  cancellationFee: Yup.number().required('Cancellation fee is required').min(0).max(999),
  cancellationDueTime: Yup.number().required('Cancellation due time is required').min(0).max(24),
  security: Yup.boolean().required('Security is required'),
  discount: Yup.number()
    .required('Discount is required')
    .min(0, 'Discount must be at least 0')
    .max(60, 'Discount must be at most 60'),
});

export default function ViewParkingDetails() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: '',
    openAt: '2018-01-01T00:00:00.000Z',
    closeAt: '2018-01-01T00:00:00.000Z',
    capacity: 0,
    description: '',
    phoneNumber: '',
    security: false,
    valet: false,
    chargingStation: false,
    servicing: false,
    wash: false,
    AdaAisleAccess: false,
    parkingRate: '',
    termAndCondition: false,
    discount: 0,
    serviceProviderId: '',
    hourlyLimit: '',
    hourlyRate: '',
    dailyLimit: '',
    dailyRate: '',
    tierType: '',
    commission: '',
    cancellationFee: '',
    cancellationDueTime: '',
    parkingTypeId: '',
  });

  const [itemData, setItemData] = useState([]);
  const token = JSON.parse(localStorage.getItem('login')).token || null;
  const [findParkingSpaceLocationById, findByIdResponse] = useFindParkingSpaceLocationByIdMutation();
  const [address, setAddress] = useState(null);
  const [addressValue, setAddressValue]: any = useState(null);
  const { parkingId } = useParams();
  const [currentStep, setCurrentStep] = useState(0);
  const [allDisabled, setAllDisabled] = useState(true);
  const [imageList, setImageList] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [tierType, setTierType] = useState([]);
  const [getParkingTypeData, getParkingTypeDataResponse] = useGetParkingTypeDataMutation();
  const [parkingManagementData, setParkingManagementData] = useState([]);

  useEffect(() => {
    findParkingSpaceLocationById({ id: parkingId, token: token });
  }, []);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      setAddressValue(() => findByIdResponse.data.address);
      setImageList(() => findByIdResponse.data.imageList);
      setFormValues(() => {
        return {
          address: findByIdResponse.data.address,
          name: findByIdResponse.data.name,
          openAt: findByIdResponse.data.openAt,
          closeAt: findByIdResponse.data.closeAt,
          capacity: findByIdResponse.data.capacity,
          description: findByIdResponse.data.description,
          phoneNumber: findByIdResponse.data.phoneNumber,
          security: findByIdResponse.data.hasSecurity,
          valet: findByIdResponse.data.hasValet,
          chargingStation: findByIdResponse.data.hasChargingStation,
          servicing: findByIdResponse.data.hasServicing,
          wash: findByIdResponse.data.hasWash,
          AdaAisleAccess: findByIdResponse.data.hasADA,
          parkingRate: findByIdResponse.data.parkingRate,
          termAndCondition: findByIdResponse.data.termAndCondition === 'true' ? true : false,
          discount: findByIdResponse.data.discount,
          serviceProviderId: findByIdResponse.data.serviceProviderId,
          photos: '',
          parkingTypeId: findByIdResponse.data.parkingTypeId,
          hourlyLimit: findByIdResponse.data.hourlyLimit,
          hourlyRate: findByIdResponse.data.hourlyRate,
          dailyLimit: findByIdResponse.data.dailyLimit,
          dailyRate: findByIdResponse.data.dailyRate,
          tierType: findByIdResponse.data.tierType,
          commission: findByIdResponse.data.commission,
          cancellationFee: findByIdResponse.data.cancellationFee,
          cancellationDueTime: findByIdResponse.data.cancellationDueTime,
        };
      });
    }
  }, [findByIdResponse.isSuccess]);

  const getParkingTypeDataAsync = async (rowPerPages: any, pages: number, orders: string, typeNames = '') => {
    await getParkingTypeData({
      token: token,
      payload: { offset: rowPerPages, pageNumber: pages, sortOrder: orders, typeName: typeNames },
    });
  };

  useEffect(() => {
    if (token) {
      getParkingTypeDataAsync(2000, 0, order);
    }
  }, []);

  useEffect(() => {
    getEnumData({ token: token });
  }, []);

  useEffect(() => {
    if (getParkingTypeDataResponse.isSuccess) {
      setParkingManagementData(getParkingTypeDataResponse.data.data);
    }
  }, [getParkingTypeDataResponse.isSuccess]);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData) {
      setTierType(enumData['TIER_TYPE']);
    }
  }, [enumData]);

  const handleAddNewParking = (values, action) => {
    setCurrentStep(1);
    setAllDisabled(true);
    setUpdatedData(values);
  };

  return (
    <Page title="Parking Space">
      <Formik
        enableReinitialize={true}
        initialValues={formValues}
        onSubmit={handleAddNewParking}
        validationSchema={ParkingSchema}
      >
        {({ values, errors, touched, handleChange, setFieldValue, handleBlur }) => {
          return (
            <Container
              sx={{
                paddingTop: '2rem',
                paddingBottom: '2rem',
              }}
            >
              <Typography variant="h3" marginBottom={'20px'} component="div">
                Details for: {values.name}
              </Typography>
              <Typography variant="h5" gutterBottom component="div">
                Parking Location
              </Typography>

              {addressValue != null && (
                <LocationSearchInput
                  disabled={allDisabled}
                  locationDetail={setAddress}
                  value={addressValue}
                ></LocationSearchInput>
              )}
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box width="70%">
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Parking Space Name
                  </Typography>
                  <TextField
                    fullWidth
                    autoComplete="name"
                    type="text"
                    name="name"
                    label="Enter Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                    disabled={allDisabled}
                  />
                </Box>
                <Box marginLeft={'40px'}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Phone Number
                  </Typography>
                  <TextField
                    type="text"
                    name="phoneNumber"
                    label="Phone Number"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                    helperText={touched.phoneNumber && errors.phoneNumber}
                    disabled={allDisabled}
                  />
                </Box>
              </Box>
              {/* Opens and closes at */}
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    label="Opens At"
                    value={values.openAt}
                    onChange={(newValue) => {
                      handleChange({ target: { name: 'openAt', value: newValue?.toString() } });
                    }}
                    error={Boolean(touched.openAt && errors.openAt)}
                    helperText={touched.openAt && errors.openAt}
                    renderInput={(params) => <TextField sx={{ marginTop: 3, marginRight: 5 }} {...params} />}
                    disabled={allDisabled}
                  />
                  <TimePicker
                    label="Closes At"
                    value={values.closeAt}
                    error={Boolean(touched.closeAt && errors.closeAt)}
                    helperText={touched.closeAt && errors.closeAt}
                    onChange={(newValue) => {
                      handleChange({ target: { name: 'closeAt', value: newValue?.toString() } });
                    }}
                    renderInput={(params) => <TextField sx={{ marginTop: 3 }} {...params} />}
                    disabled={allDisabled}
                  />
                </LocalizationProvider>
                <Box style={{ marginLeft: '40px', marginTop: '25px' }}>
                  <TextField
                    id="parking-capacity"
                    label="Parking capacity"
                    value={values.capacity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="capacity"
                    error={Boolean(touched.capacity && errors.capacity)}
                    helperText={touched.capacity && errors.capacity}
                    type={'number'}
                    disabled={allDisabled}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Hourly Limit
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <TextField
                      id="hourly-limit"
                      label="Hourly Limit"
                      value={values.hourlyLimit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="hourlyLimit"
                      error={Boolean(touched.hourlyLimit && errors.hourlyLimit)}
                      helperText={touched.hourlyLimit && errors.hourlyLimit}
                      type={'number'}
                      disabled={allDisabled}
                    />
                  </Stack>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Hourly Rate
                  </Typography>
                  <TextField
                    id="hourly-rate"
                    label="Hourly Rate"
                    value={values.hourlyRate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="hourlyRate"
                    error={Boolean(touched.hourlyRate && errors.hourlyRate)}
                    helperText={touched.hourlyRate && errors.hourlyRate}
                    type={'number'}
                    disabled={allDisabled}
                  />
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Daily Limit
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <TextField
                      id="daily-limit"
                      label="Daily Limit"
                      value={values.dailyLimit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="dailyLimit"
                      error={Boolean(touched.dailyLimit && errors.dailyLimit)}
                      helperText={touched.dailyLimit && errors.dailyLimit}
                      type={'number'}
                      disabled={allDisabled}
                    />
                  </Stack>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Daily Rate
                  </Typography>
                  <TextField
                    id="daily-rate"
                    label="Daily Rate"
                    value={values.dailyRate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="dailyRate"
                    error={Boolean(touched.dailyRate && errors.dailyRate)}
                    helperText={touched.dailyRate && errors.dailyRate}
                    type={'number'}
                    disabled={allDisabled}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Cancellation Fee
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <TextField
                      id="cancellation-fee"
                      label="Cancellation Fee"
                      value={values.cancellationFee}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="cancellationFee"
                      error={Boolean(touched.cancellationFee && errors.cancellationFee)}
                      helperText={touched.cancellationFee && errors.cancellationFee}
                      type={'number'}
                      disabled={allDisabled}
                    />
                  </Stack>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Cancellation Due Time
                  </Typography>
                  <TextField
                    id="cancellation-due-time"
                    label="Cancellation Due Time"
                    value={values.cancellationDueTime}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="cancellationDueTime"
                    error={Boolean(touched.cancellationDueTime && errors.cancellationDueTime)}
                    helperText={touched.cancellationDueTime && errors.cancellationDueTime}
                    type={'number'}
                    disabled={allDisabled}
                  />
                </Box>
                <Box width="20%" style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Select Tier Type
                  </Typography>
                  <Select
                    name="tierType"
                    id="tierType"
                    key={values.tierType}
                    value={values.tierType}
                    style={{
                      width: '100%',
                    }}
                    onChange={handleChange}
                    error={Boolean(touched.tierType && errors.tierType)}
                    disabled={allDisabled}
                  >
                    {tierType &&
                      tierType.map((tierTypes: any) => (
                        <MenuItem key={tierTypes.code} value={tierTypes.code}>
                          {tierTypes.displayValue}
                        </MenuItem>
                      ))}
                  </Select>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Commission
                  </Typography>
                  <TextField
                    id="comission"
                    label="Commission"
                    value={values.commission}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="commission"
                    error={Boolean(touched.commission && errors.commission)}
                    helperText={touched.commission && errors.commission}
                    type={'number'}
                    disabled={allDisabled}
                  />
                </Box>
              </Box>
              <Box sx={{ marginTop: '25px' }}>
                <Box>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Parking Type
                  </Typography>
                  <Select
                    id="parkingTypeId"
                    name="parkingTypeId"
                    style={{ width: '50%' }}
                    value={values.parkingTypeId}
                    onChange={(event: any) => {
                      setFieldValue('parkingTypeId', event.target.value);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.parkingTypeId && errors.parkingTypeId)}
                    disabled={allDisabled}
                  >
                    {parkingManagementData.map((parkingType: any, index: number) => (
                      <MenuItem value={parkingType.id} key={parkingType.id}>
                        {parkingType.typeName}
                      </MenuItem>
                    ))}

                    {/* <MenuItem value={1}>Flat price</MenuItem> */}
                  </Select>
                </Box>
              </Box>
              <Box sx={{ marginTop: '25px' }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Description
                </Typography>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Description"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="description"
                  multiline
                  rows={3}
                  error={Boolean(touched.description && errors.description)}
                  helperText={touched.description && errors.description}
                  disabled={allDisabled}
                />
              </Box>
              <Box sx={{ marginTop: '25px' }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Amenities
                </Typography>
                <Box display={'flex'} alignItems={'center'}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="security"
                          checked={values.security}
                          onChange={() => setFieldValue('security', !values.security)}
                          disabled={allDisabled}
                        />
                      }
                      label="Security"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="chargingStation"
                          checked={values.chargingStation}
                          onChange={() => setFieldValue('chargingStation', !values.chargingStation)}
                          disabled={allDisabled}
                        />
                      }
                      label="Charging Station"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="wash"
                          checked={values.wash}
                          onChange={() => setFieldValue('wash', !values.wash)}
                          disabled={allDisabled}
                        />
                      }
                      label="Wash"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="valet"
                          checked={values.valet}
                          onChange={() => setFieldValue('valet', !values.valet)}
                          disabled={allDisabled}
                        />
                      }
                      label="Valet"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="servicing"
                          checked={values.servicing}
                          onChange={() => setFieldValue('servicing', !values.servicing)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={allDisabled}
                        />
                      }
                      label="Servicing"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="AdaAisleAccess"
                          checked={values.AdaAisleAccess}
                          onChange={() => setFieldValue('AdaAisleAccess', !values.AdaAisleAccess)}
                          onChange={handleChange}
                          disabled={allDisabled}
                          onBlur={handleBlur}
                        />
                      }
                      label="ADA/Aisle Access"
                    />
                  </FormGroup>
                </Box>
                {/* {errors.security && touched.security && <Box sx={{ color: 'red' }}></Box>} */}
              </Box>
              <Box marginTop={'25px'}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div" disabled={allDisabled}>
                  Images
                </Typography>
                <div>
                  {imageList?.length === null ||
                    (imageList?.length > 0 && (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {imageList.map((image, index) => (
                          <Box
                            key={index}
                            sx={{
                              width: '100px',
                              height: '100px',
                              margin: '10px',
                              border: '1px solid #ccc',
                              borderRadius: '5px',
                              position: 'relative',
                            }}
                          >
                            <img
                              src={image}
                              alt={image}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                          </Box>
                        ))}
                      </Box>
                    ))}
                </div>
                <label htmlFor="contained-button-file">
                  <Input
                    accept="image/*"
                    id="contained-button-file"
                    disabled={allDisabled}
                    onChange={(data) => {
                      const reader = new FileReader();

                      reader.onload = () => {
                        if (reader.readyState === 2) {
                          setItemData((prev) => {
                            return [
                              ...prev,
                              {
                                id: Math.round(Math.random() * 100 + new Date().getTime()),
                                img: reader.result,
                                type: data.target.files[0].type,
                                file: data.target.files[0],
                              },
                            ];
                          });
                        }
                      };

                      reader.readAsDataURL(data.target.files[0]);
                    }}
                    multiple
                    type="file"
                  />
                  <Box sx={{ padding: '20px' }}>
                    {itemData.length > 0 &&
                      itemData.map((item) => (
                        <img
                          key={item.id}
                          src={`${item.img}`}
                          height={250}
                          width={250}
                          srcSet={`${item.img}`}
                          alt={item.title}
                        />
                      ))}
                  </Box>
                </label>
                {errors.photos && touched.photos && <Box sx={{ color: 'red' }}>{errors.photos}</Box>}
              </Box>
              <Box sx={{ marginTop: '25px' }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Add Terms & Conditions
                </Typography>
                <FormGroup>
                  <Stack direction="row" alignItems={'center'}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="termAndCondition"
                          checked={values.termAndCondition}
                          onChange={() => setFieldValue('termAndCondition', !values.termAndCondition)}
                          onBlur={handleBlur}
                          disabled={allDisabled}
                        />
                      }
                    />
                    <Typography variant="body1" component="span">
                      I agree to the <Link to="/terms-and-conditions"> Terms and Conditions</Link>
                    </Typography>
                  </Stack>
                  {touched.termAndCondition && errors.termAndCondition && (
                    <Typography variant="body1" component="span">
                      {errors.termAndCondition}
                    </Typography>
                  )}
                </FormGroup>
              </Box>
              <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    navigate('/dashboard/all-parking-spaces', { replace: true });
                  }}
                  sx={{ marginRight: '10px' }}
                  size="large"
                >
                  Back
                </Button>
              </div>
            </Container>
          );
        }}
      </Formik>
      {findByIdResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
